import { render, staticRenderFns } from "./HandleArticleSection.vue?vue&type=template&id=2fd70332"
import script from "./HandleArticleSection.vue?vue&type=script&lang=js"
export * from "./HandleArticleSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports